import { AnchorButton, Classes, Intent } from '@blueprintjs/core';
import * as React from 'react';
import { Tooltip } from 'vet-bones/components';

import { TEST_IDS } from 'src/constants/testIds';

type ProjectResourcePreviewDialogFooterProps = {
  backButtonText: string;
  isSubmitDisabled: boolean;
  submitButtonText?: string;
  submitErrorText?: string;
  onBack: () => void;
  onSubmit?: () => void;
};

export const ProjectResourcePreviewDialogFooter: React.VFC<
  ProjectResourcePreviewDialogFooterProps
> = ({
  backButtonText,
  isSubmitDisabled,
  submitButtonText,
  submitErrorText,
  onBack,
  onSubmit,
}) => {
  return (
    <div className={Classes.DIALOG_FOOTER}>
      <div className={Classes.DIALOG_FOOTER_ACTIONS}>
        <AnchorButton
          data-testid={TEST_IDS.projectResourceDialog.backButton}
          intent={Intent.PRIMARY}
          onClick={onBack}
          outlined
          text={backButtonText}
        />
        <Tooltip content={submitErrorText || ''} disabled={!submitErrorText}>
          <AnchorButton
            data-testid={TEST_IDS.projectResourceDialog.saveButton}
            disabled={isSubmitDisabled}
            intent={Intent.PRIMARY}
            onClick={onSubmit}
            text={submitButtonText}
          />
        </Tooltip>
      </div>
    </div>
  );
};
